type AlertTitlePropsType = {
  children: React.ReactNode;
};

const AlertTitle = ({ children }: AlertTitlePropsType): React.ReactElement => (
  <h4 className="font_headline_bold_sm mb-[12px] content_primary">
    {children}
  </h4>
);

export default AlertTitle;
